module.exports = __webpack_public_path__ + "static/media/face_2_zero.d943ca1b.svg";